import React from 'react'
import SocketBox from 'components/SocketBox/SocketBox'

export const RootWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <>
            <SocketBox />
            {children}
        </>
    )
}
